/* eslint-disable */
import { styles } from './ConstantGoogle'

const mapInit = () => {
  const mapElement = document.querySelector('#el-map')

  if (mapElement) {
    const markers = JSON.parse(mapElement.dataset.markers)
    let center
    if(window.innerWidth < 1200 && markers){
      center = {
        lat: markers[0].lat,
        lng: markers[0].lng,
      };
    } else {
      center = JSON.parse(mapElement.dataset.center)
    }
    const zoom = Number(mapElement.dataset.zoom)
    const icon = mapElement.dataset.icon

    const map = new google.maps.Map(document.getElementById('el-map'), {
      disableDefaultUI: false,
      center: center,
      zoom: zoom,
      styles: styles.darker,
      panControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      overviewMapControl: false,
      rotateControl: false,
      draggable: true,
    })

    const infowindow = new google.maps.InfoWindow()

    for (let i = 0; i < markers.length; i++) {
      const marker = new google.maps.Marker({
        position: {
          lat: Number(markers[i].lat),
          lng: Number(markers[i].lng),
        },
        icon: {
          url: icon,
        },
        map: map,
      })

      google.maps.event.addListener(marker, 'click', (function (marker, index) {
        return function () {
          var dataFromLS = '<div class="el-google__top">\n' +
            '                    <div class="g-row">\n' +
            '                        <div class="g-cols g-cols--auto g-cell">\n' +
            '                            <div class="el el--p_b_xs">\n' +
            '                                <div class="ds-caption ds-caption--c_black ds-caption--size_xs ds-caption--w_r ds-caption--h_130">\n' +
            `                                    ${markers[index].top}\n` +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="ds-caption ds-caption--c_grey ds-caption--size_xs ds-caption--w_l ds-caption--h_130">\n' +
            `                                ${markers[index].address}` +
            '                            </div>\n' +
            '                        </div>\n' +
            '                        <div class="g-cols g-cols--narrow g-cell">\n' +
            '                            <div class="rel"><a class="pos_abs"\n' +
            '                                                href="https://maps.google.com/maps/dir//Severinstra%C3%9Fe+80+50678+K%C3%B6ln+%D0%93%D0%B5%D1%80%D0%BC%D0%B0%D0%BD%D0%B8%D1%8F/@50.9256299,6.9585037,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x47bf244c23b588c5:0x57d681c54d464dad"\n' +
            '                                                target="_blank"></a>\n' +
            '                                <div class="g-row g-row--appearance_column g-row--align_center g-cell"><img\n' +
            `                                        class="img img--map-icon" src="${markers[index].src}"/><a\n` +
            '                                        class="ds-caption ds-caption--c_black ds-caption--size_xs ds-caption--w_l ds-caption--h_200 ds-caption--hover_line black"\n' +
            '                                        href="https://maps.google.com/maps/dir//Severinstra%C3%9Fe+80+50678+K%C3%B6ln+%D0%93%D0%B5%D1%80%D0%BC%D0%B0%D0%BD%D0%B8%D1%8F/@50.9256299,6.9585037,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x47bf244c23b588c5:0x57d681c54d464dad"\n' +
            `                                        target="_blank">${markers[index].text_go}</a>\n` +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            `                        <div class="g-cols g-cols--12 g-cell el el--m_t_xs"><a class="ds-caption ds-caption--c_black ds-caption--size_xs ds-caption--w_l ds-caption--h_200 ds-caption--hover_line black" href="https://maps.google.com/maps?ll=50.92563,6.958504&amp;z=16&amp;t=m&amp;hl=ru&amp;gl=UA&amp;mapclient=embed&amp;q=Severinstra%C3%9Fe%2080%2050678%20K%C3%B6ln%20%D0%93%D0%B5%D1%80%D0%BC%D0%B0%D0%BD%D0%B8%D1%8F" target="_blank">${markers[index].text_view}</a> </div>\n` +
            '                    </div>\n' +
            '                </div>'
          // infowindow.setContent(markers[index].address)
          infowindow.setContent(dataFromLS)
          infowindow.open(map, marker)
        }
      })(marker, i))
    }
  }
}

export default mapInit



// WEBPACK FOOTER //
// ./src/js/customs/google/MapGoogle.js